<div class="flex flex-col items-center justify-center min-h-screen text-center bg-gray-50 dark:bg-gray-900 text-gray-800 dark:text-gray-200 p-4">
  <div class="max-w-md mx-auto p-8 rounded-xl shadow-lg bg-white dark:bg-gray-800 transition-all duration-300 transform hover:scale-105">
    <div class="flex flex-col items-center mb-6">
      <i class="material-icons text-9xl text-indigo-600 dark:text-indigo-400 mb-4 transition-transform duration-300 transform hover:rotate-6 hover:scale-110">
        sentiment_very_dissatisfied
      </i>
      <h1 class="text-7xl font-extrabold tracking-tight text-gray-900 dark:text-white">404</h1>
    </div>
    <div class="text-lg text-gray-600 dark:text-gray-300 mb-6">
      <h2 class="text-3xl font-bold mb-2">Page Not Found</h2>
      <p class="mt-2">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
    </div>
    <button (click)="navigate()" class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
      <i class="material-icons mr-2">home</i>
      {{ buttonText }}
    </button>
  </div>
</div>
